import { Input } from '@chakra-ui/react'
import { clsx } from 'clsx'
import { forwardRef } from 'react'

import type { InputHTMLAttributes } from 'react'

type TextFieldProperties = Omit<InputHTMLAttributes<HTMLInputElement>, 'size'>

export const TextField = forwardRef<HTMLInputElement, TextFieldProperties>(
  ({ className, type = 'text', ...properties }, reference) => {
    /* --- Section 6: Render --- */
    return (
      <Input
        {...properties}
        bg="var(--theme-card-background)"
        borderRadius="[var(--radius-sm)]"
        className={clsx('ui-text-field', className)}
        color="var(--theme-text-color)"
        fontSize="[14px]"
        h="[44px]"
        px="[14px]"
        ref={reference}
        type={type}
        _disabled={{
          cursor: '[not-allowed]',
          opacity: '[0.6]',
        }}
        _placeholder={{
          color: 'var(--theme-text-color-muted)',
        }}
      />
    )
  }
)

TextField.displayName = 'TextField'
